import { atom } from 'klyva';

export const authStore = atom<{ isAuthenticated: boolean }>({
    isAuthenticated: (() => {
        const session = localStorage.getItem('user_session');
        return session ? JSON.parse(session).isAuthenticated === true : false;
    })(),
});

// authStore.subscribe((state) => {
//     localStorage.setItem('isAuthenticated', String(state.isAuthenticated));
// });

export const login = () => {
  authStore.update(() => ({ isAuthenticated: true }));
};

export const logout = () => {
  authStore.update(() => ({ isAuthenticated: false }));
};